/**
 * In-memory store for the JWT passed from the admin client app to the
 * survey preview window via postMessage. Never written to localStorage
 * or the URL — lives only for the lifetime of this tab.
 */

let previewToken = null;

export function setPreviewToken(token) {
  previewToken = token;
}

export function getPreviewToken() {
  return previewToken;
}
